'use client'

import { useMemo } from "react"
import ProductCard from "../product/ProductCard"
import { ArrowRight, PackageOpen } from "lucide-react"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"

export default function Products({ products, vendor, title, limit, description, viewAllUrl }: { products: any[], vendor: any, wishlist?: any, title: string, limit?: number, description?: string, viewAllUrl?: string }) {
  const pathname = usePathname()

  const desktopCount = 8
  const mobileCount = 6
  const itemCount = limit || Math.max(mobileCount, desktopCount)

  const displayProducts = useMemo(() => {
    return (products || []).slice(0, itemCount)
  }, [products, itemCount])

  return (
    <div className="cont pt-12 pb-4">
      <div className="flex items-end justify-between gap-4 mb-7">
        <div className="max-w-2xl">
          <div className="text-[10px] font-semibold uppercase tracking-[0.2em] mb-2.5" style={{ color: '#a8a8b3' }}>
            {description || 'Цуглуулга'}
          </div>
          <h2 className="text-2xl sm:text-[34px] font-semibold tracking-[-0.02em] leading-none" style={{ fontFamily: 'Gilroy, Inter, sans-serif', color: 'white' }}>
            {title}
          </h2>
        </div>
        {viewAllUrl && displayProducts.length > 0 && (
          <a href={navigateUrl(viewAllUrl, pathname)} className="text-[13px] font-medium inline-flex items-center gap-1.5 px-4 h-9 rounded-full shrink-0" style={{ color: 'rgba(255,255,255,0.9)', background: 'rgba(255,255,255,0.035)', border: '1px solid rgba(255,255,255,0.07)' }}>
            Бүгдийг харах <ArrowRight className="w-3.5 h-3.5" />
          </a>
        )}
      </div>
      {displayProducts.length > 0 ? (
        <>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-10">
            {displayProducts.map((product: any, index: number) => (
              <div key={product.customId || product.id}>
                <ProductCard product={product} vendor={vendor} />
              </div>
            ))}
          </div>
          {viewAllUrl && (
            <div className="flex items-center justify-center sm:hidden mt-10">
              <a href={navigateUrl(viewAllUrl, pathname)} className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-full text-[13px] font-medium w-full" style={{ background: 'rgba(255,255,255,0.06)', color: 'white', border: '1px solid rgba(255,255,255,0.14)' }}>
                Бүгдийг харах <ArrowRight className="w-3.5 h-3.5" />
              </a>
            </div>
          )}
        </>
      ) : (
        <div className="flex flex-col items-center justify-center gap-3 py-16" style={{ color: 'rgba(255,255,255,0.5)' }}>
          <PackageOpen className="w-8 h-8" />
          <div className="text-[14px]">Бүтээгдэхүүн байхгүй байна</div>
        </div>
      )}
    </div>
  )
}
